import React, { useEffect, useState } from "react";
import { Form, Row } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";

const PatientPhone = ({ phoneObj, deletePhone, refresh, setRefresh }) => {
  const [phone, setPhone] = useState(phoneObj.phone);
  useEffect(() => {
    phoneObj.phone = phone;
    if (setRefresh) {
      setRefresh(!refresh);
    }
  }, [phone]);
  return (
    <Row className="border border-dark mb-2 py-3">
      <Row className="flex-row-reverse w-100 mt-2 ">
        {/* Phone Field */}
        <Form.Group controlId="phone" className="col-10 ">
          <Form.Control
            type="text"
            className="text-center"
            placeholder="الرقم"
            value={phone}
            isValid={phone}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                // only digits allowed
                setPhone(value);
              }
            }}
          />
        </Form.Group>

        {/* Delete Icon */}
        <Form.Group className="col-2 text-center">
          <FaTrashAlt
            className="text-danger"
            onClick={() => deletePhone(phoneObj)}
          />
        </Form.Group>
      </Row>
    </Row>
  );
};

export default PatientPhone;
